import React, { createContext } from 'react'
import {
  ILaneModalState,
  ILaneModalAction,
  laneModalInitialState,
} from 'apps/marketplace/utils/reducers/contractLaneModal'

const initialModalState = { state: laneModalInitialState, dispatch: () => {} }
export const EditLaneModalContext = createContext<{
  state: ILaneModalState
  dispatch: React.Dispatch<ILaneModalAction>
}>(initialModalState)
export const LaneRemoveModalContext = createContext<{
  state: ILaneModalState
  dispatch: React.Dispatch<ILaneModalAction>
}>(initialModalState)

export const { Provider: EditLaneModalProvider } = EditLaneModalContext
export const { Provider: LaneRemoveModalProvider } = LaneRemoveModalContext
